"use client";
import { useThemeColor } from "@/hooks/useThemeColor";

interface ChatLayoutProps {
  children: React.ReactNode;
}

export default function ChatLayout({ children }: ChatLayoutProps) {
  // 设置浏览器工具栏颜色与聊天页面背景一致
  useThemeColor("#f9f7f1");
  return (
    children
  );
}
